<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M12 9.4q-1 0-2 .8-.7.7-.7 1.8t.8 1.8q.8.8 1.9.8t2-.8q.6-.7.7-1.8t-.8-1.8q-.8-.8-1.9-.8m0 7q-1.9 0-3.2-1.3T7.5 12t1.3-3T12 7.6t3.2 1.2 1.3 3.1-1.3 3-3.2 1.3m0-10.9C7.5 5.5 3.6 8.2 2 12c1.6 3.8 5.5 6.5 10 6.5s8.4-2.7 10-6.5a11 11 0 0 0-10-6.5"
    />
  </svg>
</template>
